var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSecure1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,9.25A14.76686,14.76686,0,0,0,25.25,24v6.7005a22.75,22.75,0,1,0,29.5,0V24A14.76686,14.76686,0,0,0,40,9.25ZM26.75,24a13.25,13.25,0,0,1,26.5,0v5.52441a22.67367,22.67367,0,0,0-26.5,0Zm34.5,24A21.25,21.25,0,1,1,40,26.75,21.27376,21.27376,0,0,1,61.25,48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25,48A8.75,8.75,0,1,0,40,39.25,8.75967,8.75967,0,0,0,31.25,48Zm16,0A7.25,7.25,0,1,1,40,40.75,7.258,7.258,0,0,1,47.25,48Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 44,
    width: 1.5,
    height: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure1);
export default __webpack_public_path__ + "static/media/icon_secure_1.bb3b84297d30f63a6bd2c44305467b9d.svg";
export { ForwardRef as ReactComponent };